
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/messenger",
      function () {
        return require("private-next-pages/messenger/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/messenger"])
      });
    }
  